/* global axios */
import ApiClient from './ApiClient';

class EmailMarketingProviders extends ApiClient {
  constructor() {
    super('email_marketing_providers', { accountScoped: true });
  }

  list() {
    return axios.get(this.url);
  }

  get(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, { email_marketing_provider: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { email_marketing_provider: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  test(id, toEmail) {
    return axios.post(`${this.url}/${id}/test`, { to: toEmail });
  }
}

export default new EmailMarketingProviders();
